<template>
  <div class="header-wrapper">
    <div class="header">
      <div class="left">
        <div class="logo">
          <span class="product-name">{{ user.platform }}</span>
          <span class="version">{{ version.version }}</span>
        </div>
        <div class="routes">
          <div
            class="route-item" 
            v-for="(item, index) in routes"
            :key="index"
            @mouseenter="toggleNavs(item)"
            @click="handleClickNav(item)"
          >
            <img
              :src="item.icon"
              class="icon"
              />
            <p class="title">{{ item.name }}</p>
          </div>
        </div>
      </div>
      <div class="right">
        <div v-if="user.ins_tenant_id > 0" class="d-flex mr10">
          <label>切换租户：</label>
          <tenantSelection @clickTenant="changeTenant" :data="tenantData"></tenantSelection>
        </div>
        <div v-else class="d-flex mr20">
          <!-- <label>租户：</label> -->
          <span>{{ user.tenant_name }}</span>
        </div>
        <p class="time" :title="`${$moment(system.time).format('yyyy-MM-DD HH:mm:ss dddd')}`">
          <!-- <i class="el-icon-date"></i> -->
          <span>
            {{$moment(system.time).format('yyyy-MM-DD HH:mm:ss dddd')}}
          </span>
        </p>
        <el-dropdown trigger="click" @visible-change="clickBut" @command="handleDropdown" class="logout">
          <span class="el-dropdown-link">
            <span class="user-name" :title="user.name">{{user.name}}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            
            <el-dropdown-item v-show="version.locale_on" command="language">
              <el-popover
                placement="left"
                trigger="hover"
                popper-class="service-contract-popover"
              >
                <div slot>
                  <p 
                    class="hd-language-item"
                    :class="{'active': item.localKey === lang}"
                    v-for="(item, index) in langOptions" 
                    :key="index" 
                    @click="changeLang(item)">
                    {{ item.name }}
                  </p>
                </div>
                <span slot="reference">设置语言</span>
              </el-popover>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-popover
                placement="left"
                :title="`扫码下载（仅安卓）`"
                trigger="hover"
                popper-class="service-contract-popover"
              >
                <span slot>
                  <img class="contract-qr" :src="appDownloadCodeImage" />
                </span>
                <span slot="reference">下载App</span>
              </el-popover>
            </el-dropdown-item>
            <!-- <el-dropdown-item v-for="item in custServInfo" :key="item.value">
              <el-popover
                placement="left"
                :title="`请用微信扫码`"
                trigger="hover"
                popper-class="service-contract-popover"
              >
                <span slot>
                  <vue-qr :margin="0" :logoScale="0.2" :logoSrc="getImg(item)" :text="item.name_en" :size="200"></vue-qr>
                </span>
                <span slot="reference">{{item.name}}</span>
              </el-popover>
            </el-dropdown-item> -->
            <el-dropdown-item command="personalCenter">
              个人中心
              <!-- 修改密码 -->
            </el-dropdown-item>
            <el-dropdown-item command="downloadPrinterDriver">下载打印机驱动</el-dropdown-item>
            <el-dropdown-item command="commonProblem">常见问题</el-dropdown-item>
            <el-dropdown-item command="scanActivation">激活打印机</el-dropdown-item>
            <el-dropdown-item command="writeOff">核销</el-dropdown-item>
            <el-dropdown-item command="updateLogs">更新日志
              <span v-if="isUnread" class="unread">new</span>
            </el-dropdown-item>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="route-navs" v-show="navs && navs.length" @mouseleave="navs = []">
      <div
        class="nav"
        v-for="item in navs"
        :key="item.id"
        @click="goPath(item)"
      >
        {{ item.name }}
      </div>
    </div>
    <!-- 激活打印机 -->
    <el-dialog :title="`激活打印机`" :visible.sync="dialogVisible" width="800px">
      <div style="text-align:center">请扫描打印机编码和填写机器序列号</div>
      <div class="dialog-acti-row mt20">
        <div>打印机编码</div>
        <el-input @blur="activatePrinter" class="input200 ml20" v-model="printerNum" />
      </div>
      <div class="dialog-acti-row mt20" v-if="serial_number">
        <div>{{serial_number}}</div>
        <!-- 请输入机器序列号后四位 -->
        <el-input :maxlength="4" :placeholder="`请输入机器序列号后四位`" class="input200 ml10" v-model="fourNum" />
      </div>
      <div style="text-align:center" class="mt20">
        <el-button plain @click="dialogVisible = false">关闭</el-button>
        <el-button :disabled="!serial_number" type="primary" @click="confirmActivation">确定</el-button>
      </div>
    </el-dialog>
    <!-- 核销 -->
    <el-dialog :title="`核销`" :visible.sync="dialogVisible2" width="800px">
      <!-- 请扫描标签二维码 -->
      <div style="text-align:center">请扫描标签二维码</div>
      <div class="dialog-acti-row mt20">
        <!-- 二维码编码 -->
        <div>二维码编码</div>
        <el-input @blur="activateQR" v-model="QRcode" class="input200 ml20" />
      </div>
      <div style="text-align:center" class="mt20">
        <el-button plain @click="dialogVisible2 = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 个人中心 -->
    <el-dialog :title="`个人中心`" :visible.sync="dialogVisible3" width="1300px">
      <div class="ml20 mr20 mt20">
        <el-row class="mb20">
          <el-col :span="6">
            <!-- 用户账号 -->
            <span class="label-cla label-width">用户账号：</span>
            <span class="cell-cla">{{ userData.user_name }}</span>
          </el-col>
          <el-col :span="6">
            <!-- 姓名 -->
            <span class="label-cla label-width">姓名：</span>
            <span class="cell-cla">{{ userData.name }}</span>
          </el-col>
          <el-col :span="6">
            <!-- 租户名称 -->
            <span class="label-cla label-width">租户名称：</span>
            <span class="cell-cla">{{ userData.tenant_name }}</span>
          </el-col>
          <el-col :span="6">
            <!-- 科室名称 -->
            <span class="label-cla label-width">科室名称：</span>
            <span class="cell-cla">{{ userData.department_name }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- 身份 -->
            <span class="label-cla label-width">身份：</span>
            <span class="cell-cla">{{ userData.role_name }}</span>
          </el-col>
          <el-col :span="6">
            <!-- 状态 -->
            <span class="label-cla label-width">状态：</span>
            <span class="cell-cla">{{ userData.status_text }}</span>
          </el-col>
          <el-col :span="6">
            <!-- 手机号 -->
            <span class="label-cla label-width">手机号：</span>
            <span class="cell-cla">{{ userData.mobile }}</span>
          </el-col>
          <el-col :span="6">
            <!-- 密码： -->
            <span class="label-cla label-width">密码：</span>
            <span class="cell-cla pointer" @click="changePwd">******<i class="el-icon-edit-outline"></i></span>
            
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="10">
          <el-col :span="8" v-if="userData.auth_type == 1">
            <!-- 租户有效期 -->
            <span class="label-cla">租户有效期：</span>
            <span class="cell-cla">{{ userData.tenant_start_time }} 至 {{ userData.tenant_end_time }}</span>
          </el-col>
          <el-col :span="8" v-else-if="userData.auth_type == 2">
            <!-- 租户可用标签数量（张） -->
            <span class="label-cla">租户可用标签数量（张）：</span>
            <span class="cell-cla">{{ userData.effective_tag_number }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label-cla">租户可用打印机数量（台）：</span>
            <span class="cell-cla">{{ userData.printer_effective_number }}</span>
          </el-col>
          <el-col :span="8">
            <!-- 租户维保到期打印机数量（台） -->
            <span class="label-cla">租户维保到期打印机数量（台）：</span>
            <span class="cell-cla">{{ userData.printer_expire_number }}</span>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!-- 核销标签码记录 -->
          <el-tab-pane :label="`核销标签码记录`" name="first">
            <el-table class="mt10" ref="multipleTable" border :data="codeTraceList">
              <el-table-column type="index" label="#" width="55"></el-table-column>
              <el-table-column v-for="item in codeTraceColumns" :label="item.text" :key="item.column" :width="item.width">
                <template slot-scope="scope">
                  <!-- 二维码 -->
                  <img v-if="item.column == 'code_preview'" @click="showQRCode(scope.row.code)" :src="`${$utils.generateCode(scope.row.code, 'qrcode')}`" alt="" class="qr-code" />
                  <span v-else>{{ scope.row[item.column] }}</span>
                </template>
              </el-table-column>
            </el-table>
            <pagination :queryParams="queryParams1" :getList="getCodeTrace" />
          </el-tab-pane>
          <!-- 激活打印机记录 -->
          <el-tab-pane :label="`激活打印机记录`" name="second">
            <el-table class="mt10" ref="multipleTable" border :data="printList">
              <el-table-column type="index" label="#" width="55"></el-table-column>
              <el-table-column v-for="item in printColumns" :label="item.text" :key="item.column" :width="item.width">
                <template slot-scope="scope">
                  <span>{{ scope.row[item.column] }}</span>
                </template>
              </el-table-column>
            </el-table>
            <pagination :queryParams="queryParams2" :getList="getCodeTrace" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>

    <!-- 二维码预览 -->
    <el-dialog :title="`二维码预览`" :visible.sync="dialogVisible4" width="1000px">
      <div style="text-align: center">
        <img v-if="imgQRCode" :src="`${$utils.generateCode(imgQRCode, 'qrcode')}`" alt="" class="qr-code-big" />
      </div>
    </el-dialog>

    <!-- 修改密码 -->
    <el-dialog :title="`修改密码`" :visible.sync="dialogVisible5" width="800px">
      <div class="p20 modify-box">
        <div>
          <label class="label">旧密码：</label>
          <el-input
            class="ml5 search-input"
            v-model="old_password"
            type="password"
            clearable
            :placeholder="`请输入旧密码`"></el-input>
        </div>
        <div class="mt10">
          <label class="label">新密码：</label>
          <el-input 
            class="ml5 search-input" 
            v-model="new_password" 
            type="password"
            clearable 
            :placeholder="`请输入新密码`"></el-input>
        </div>
        <div class="mt10">
          <label class="label">确认密码：</label>
          <el-input 
            class="ml5 search-input" 
            v-model="confirm_password" 
            type="password"
            clearable 
            :placeholder="`请确认密码`"></el-input>
        </div>
        
        <el-button class="mt20" type="primary" size="mini" @click="getPassword">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tenantSelection from '@/components/common/tenantSelection'
import VueQr from 'vue-qr'
import Pagination from '@/components/common/Pagination';
import { pageSize } from '@/utils/Config';
import { mapGetters } from 'vuex'
import { userTokenKey, localLabelKey, langKey, apiLangKey } from '@/utils/Config.js'
import { setCenter, setUserLang, setTenant, codeTraceVerified,printerNumberQuery,printerActivate, codeTraceList, printer, userPwd, userCenter,iterationLogIsUnRead } from '@/api.js'
import store from '@/store';
const appDownloadCodeForTest = require('@/assets/img/test-latest.png')
const appDownloadCodeForProduction = require('@/assets/img/release-latest.png')
const appDownloadCodeForLang = require('@/assets/img/lang-latest.png')
export default {
  name: 'Header',
  components: {
    Pagination,
    VueQr,
    tenantSelection
  },
  data() {
    const langValue = localStorage.getItem(langKey)
    return {
      tenantData:{
        inputData:''
      },
      custServInfo:[],
      isUnread:false,
      userData:{},
      old_password:'',
      new_password: '',
      confirm_password: '',
      dialogVisible5:false,
      queryParams1: {
        pageIndex: 1,
        pageSize: pageSize,
        _total: 0,
      },
      queryParams2: {
        pageIndex: 1,
        pageSize: pageSize,
        _total: 0,
      },
      printList:[],
      printColumns:[],
      codeTraceList:[],
      dialogVisible4:false,
      imgQRCode:'',
      codeTraceColumns:[],
      activeName: 'first',
      fourNum:'',
      serial_number:'',
      printerNum:'',
      QRcode:'',
      dialogVisible:false,
      dialogVisible2:false,
      dialogVisible3:false,
      lang: langValue,
      socket: null,
      navs: [],
      tenant_id: undefined
    }
  },
  computed: {
    ...mapGetters(['user', 'version', 'system', 'information', 'langOptions', 'menu','addressOptions']),
    routes() {
      const routes = [
        {
          name: `主页`,
          parentId: 0,
          icon: require('@/assets/img/home/index.png')
        },
        
      ]

      if (this.user.role_id === 1 || this.user.role_id === 2 || this.user.role_id === 5 || this.user.role_id === 6) {
        routes.push({
          name: `基础数据`,
          parentId: 1,
          icon: require('@/assets/img/home/basic.png')
        })
      }
      routes.push({
          name: `产品介绍`,
          parentId: 2,
          icon: require('@/assets/img/home/productIntroduction.png')
        })
      if(this.user.role_id == 1 || this.user.role_id == 5 || this.user.role_id == 6){
        routes.push({
          name: `系统管理`,
          parentId: 242,
          icon: require('@/assets/img/home/setting.png')
        })
      }
      return routes
    },
    appDownloadCodeImage() {
      let imageUrl = appDownloadCodeForTest
      const { NODE_ENV, VUE_APP_BASE } = process.env
      if (VUE_APP_BASE) {
        imageUrl = appDownloadCodeForLang
      } else if (NODE_ENV === 'production') {
        imageUrl = appDownloadCodeForProduction
      }

      return imageUrl
    },
  },
  created() {
    this.tenantData.inputData = this.user.tenant_name;
    this.listenScan()
    store.dispatch('setAddressOptions')
    // 字典
    this.$utils.getDict([612]).then((res) => {
      if (res) {
        this.custServInfo = res[612]
      }
    })
  },
  mounted() {
    this.listenSocket()
    window.document.title = `红柚“安易溯”标签管家`
  },
  methods: {
    getImg(data){
      try {
        let img = require(`./../../../public/static/images/custServ/custServ${data.value}.jpg`)
        if(img){
          return img
        }else{
          return ''
        }
      }catch{
        return ''
      }
    },

    async listenSocket() {
      // 监听socket
      this.socket = await this.$socket()
      if (this.socket) {
        this.socket.on('logout', (msg) => {
          const token = this.$cookie.get(userTokenKey)
          if (msg !== token) {
            this.logout()
          }
        })
      }
    },
    toggleNavs(item) {
      const {
        parentId
      } = item

      const matchMenuItem = this.menu.find(i => i.id === parentId)
      this.navs = matchMenuItem ? matchMenuItem.children || [] : []
    },
    handleClickNav(item) {
      const {
        parentId
      } = item

      if (parentId === 0) { // 点击的是主页
        this.$router.push('/index')
      }else if(parentId === 2){ // 点击的是产品介绍
        this.$router.push('/portal')
      }
    },
    goPath(item) {
      const {
        href
      } = item

      this.$router.push(href)
    },
    clickBut(data){
      this.isUnread = false
      if(data){
        this.$request('get',iterationLogIsUnRead).then(res=>{
          this.isUnread = res.unread
        })
      }
    },
    handleDropdown(command) {
      // 退出登录
      if (command === 'logout') {
        this.logout()
      } else if (command === 'personalCenter') {
        this.personalCenter()
      } else if (command === 'scanActivation') {
        this.scanActivation()
      }
      else if (command === 'writeOff') {
        this.writeOff()
      }
      else if (command === 'updateLogs'){
        this.updateLogs()
      }
      else if (command === 'downloadPrinterDriver') {
        this.downloadPrinterDriver()
      } else if(command === 'commonProblem'){
        this.commonProblem()
      }
      
    },

    // 常见问题
    commonProblem(){
      this.$router.push('/basic/commonProblem/index')
    },

    // 下载打印机驱动
    downloadPrinterDriver(){
      var element = document.createElement('a');
      element.setAttribute('href', 'https://resource.honjoinfo.com:8081/finder?action=share.download&key=cace-aebf-941e3f802417183fd3738e30a428acc4ba2b0a77f585b6ffaabc1a1fb6da73d7');
      element.setAttribute('download', `打印机文件`);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },

    // 打开修改密码弹框：
    changePwd(){
      this.dialogVisible5 = true
      this.old_password = ''
      this.new_password = ''
      this.confirm_password = ''
    },

    //确认修改密码
    getPassword(){
      const {
        old_password,
        new_password,
        confirm_password
      } = this

      this.$request('post', userPwd, {
        old_password,
        new_password,
        confirm_password
      }).then((res) => {
        if(res){
            this.$message.success(`修改成功`)
            window.location.replace('/login')
        }
      })
    },

    // 监听扫码
    listenScan() {
    this.$scan(document, {
    onScan: (code) => {
          if (code) {
            this.scanFunc(code)
          }
        }
      })
    },
    
    // 扫描的方法
    scanFunc(code){
      if(this.dialogVisible){ //如果是激活打印机        
        this.printerNum = ''
        this.printerNum = code
        this.activatePrinter()
      }else if(this.dialogVisible2){ //如果是核销
      this.QRcode = ''
      this.QRcode = code
      this.activateQR()
      }
    },

    //激活打印机
    activatePrinter(){
      this.$request('get', printerNumberQuery, { number: this.printerNum }).then((res) => {
        if (res) {
          this.serial_number = res.serial_number
        }
      })
    },

    //激活二维码
    activateQR(){
      this.$request('post', codeTraceVerified, { code: this.QRcode }).then((res) => {
        if (res) {
          this.$message.success(res.msg)
        }
      })
    },

    // 显示 核销 弹框
    writeOff(){
      this.dialogVisible2 = true
      this.QRcode = ''
    },

    // 更新日志
    updateLogs(){
      this.$router.push('/basic/updateLogs/index')
    },

    // 显示 扫码激活打印机 弹框
    scanActivation(){
      this.dialogVisible = true
      this.printerNum = ''
      this.fourNum = ''
      this.serial_number = ''
    },

    // 确定激活打印机
    confirmActivation(){
      if(!this.printerNum){
        this.$message.warning(`请扫描打印机编号`)
        return
      }
      if(this.fourNum.length != 4){
        this.$message.warning(`请输入序列号后四位`)
        return
      }
      this.$request('post', printerActivate, { 
        number: this.printerNum, 
        serial_number: this.serial_number + this.fourNum
        }).then((res) => {
          if (res) {
            this.$message.success(`打印机激活成功`)
            this.dialogVisible = false
          }
        })
    },

    logout() {
      this.$cookie.remove(userTokenKey)
      this.$router.replace('/login')
      this.$utils.delLocal(localLabelKey)
      if (this.socket) {
        this.socket.disconnect()
        setTimeout(() => {
          this.socket = null
        }, 800)
      }
    },
    personalCenter() {
      this.dialogVisible3 = true
      this.getUserCenter()
      this.getCodeTrace()
    },

    // 获取个人信息
    getUserCenter(){
      this.$request('get', userCenter).then((res) => {
        if (res) {
          this.userData = res
        }
      });
    },

    //获取核销标签码列表
    getCodeTrace(){
      const { pageIndex, pageSize } = this.queryParams1;
      const query = {
        page: pageIndex,
        per_page: pageSize,
        type:2,
      };
      this.$request('get', codeTraceList, query).then((res) => {
        if (res) {
          this.codeTraceList = res.data;
          this.codeTraceColumns = res.columns;
          this.queryParams1._total = res.total;
        }
      });
    },

    // 获取激活打印机的列表数据
    getPrinterList() {
      const { pageIndex, pageSize } = this.queryParams2;
      const query = {
        page: pageIndex,
        per_page: pageSize,
        type:2
      };
      this.$request('get', printer, query).then((res) => {
        if (res) {
          this.printList = res.data;
          this.printColumns = res.columns;
          this.queryParams2._total = res.total;
        }
      });
    },

    // 展示二维码
    showQRCode(code) {
      this.imgQRCode = code;
      this.dialogVisible4 = true;
    },

    // 切换tab时的方法
    handleClick() {
      // 当切换tab页面时，如果没有数据的时候，需要加载数据
      if (this.activeName == 'second' && this.printList.length == 0) {
        this.getPrinterList();
      }
    },
    confirmHandleCenter(value) {
      this.$request('post', setCenter, { center_id: value })
      .then((res) => {
        if (res) {
          window.location.reload()
        }
      })
    },
    changeLang(item) {
      // 切换语言
      if (item.localKey === this.lang) return

      const {
        apiKey,
        localKey
      } = item
      this.$request('post', setUserLang, {
        locale: apiKey
      })
      .then(res => {
        if (res) {
          localStorage.setItem(langKey, localKey)
          localStorage.setItem(apiLangKey, apiKey)
          const { fullPath } = this.$route
          const { NODE_ENV } = process.env
          const langRoute = NODE_ENV.includes('dev') ? '' : `/${apiKey}`
          const url = `${window.location.origin}${langRoute}${fullPath}`
          
          window.location.href = url
        }
      })
    },
    changeTenant(data) {
      // return
      // const {
      //   tenant_id
      // } = this.user
      this.$request('post', setTenant, {
        tenant_id:data.id
        // tenant_id
      }).then(res => {
        if (res) {
          window.location.reload()
        }
      })
    },
  }
}
</script>
<style lang="scss">
 .service-contract-popover {
  .el-popover__title {
    text-align: center;
    color: gray;
    margin-bottom: 0;
  }
  .contract-qr {
    width: 200px;
    height: 200px;
  }
 }
</style>

<style lang="scss" scoped>
  @import '@/assets/css/common.scss';
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 60px;
    top: 0;
    left: 0;
    position: fixed;
    z-index: 1000;
    box-shadow: 0px 0px 15px #aeaba5;
    background-color: #fff;
    .left, .right {
      display: flex;
      align-items: center;
      height: 100%;
    }
    .right {
      padding: 0 15px 0 0;
      .sub-title {
        color: gray;
      }
    }
    .logo {
      width: 220px;
      height: 100%;
      display: flex;
      justify-content: center;
      color: #fff;
      background-color: $main_color;
      flex-shrink: 0;
      align-items: center;
      .product-name {
        font-size: 26px;
        letter-spacing: 2px;
      }
      .version {
        font-size: 14px;
        font-weight: 400;
        margin: 0 0 -14px 8px;
      }
      img {
        height: 100%;
        max-width: 96%;
      }
    }
    .time {
      font-size: 25px;
      color: gray;
      font-weight: bold;
      flex-shrink: 0;
      margin-right: 50px;
    }
    .avatar {
      margin: 0 14px;
      width: 40px;
      flex-shrink: 0;
    }
    .user-name {
      display: inline-block;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: middle;
    }
    .el-dropdown-link {
      cursor: pointer;
    }
    .logout {
      flex-shrink: 0;
    }
    .tag-box {
      display: flex;
      align-items: baseline;

      .tag-name {
        display: inline-block;
        width: 50px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .routes {
      display: flex;
      padding: 0 10px;
      .route-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 10px;
        cursor: pointer;
        .icon {
          width: auto;
          height: 30px;
        }
        .title {
          font-size: 12px;
          color: #898989;
          font-weight: 400;
          text-align: center;
        }
      }
    }
    .route-navs {
      position: absolute;
      width: 100%;
      height: 80px;
      background-color: #fff;
      top: 60px;
      padding: 0 20px 0 20px;
      display: flex;
      align-items: center;
      z-index: 999;
      .nav {
        width: auto;
        height: 46px;
        background-color: #F5F6F7;
        border-radius: 2px;
        text-align: center;
        line-height: 46px;
        cursor: pointer;
        margin: 0 12px 0 0;
        font-size: 14px;
        padding: 0 20px;
        &:hover {
          background-color: #F0F9FB;
          color: $main_color_deep;
        }
      }
    }
.dialog-acti-row{
display: flex;
align-items: center;
justify-content: center;
}
.qr-code-big {
  width: 300px;
  height: 300px;
}
.qr-code {
  height: 80px;
  width: 80px;
}
.modify-box{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.label{
  width: 85px;
  display: inline-block;
}
.label-cla{
  font-size: 16px;
  font-weight: bold;
  color: #000;
}
.label-width{
    display:inline-block;
    width: 100px;
  }
.pointer{
  cursor: pointer;
}

</style>
<style lang="scss">
   @import '@/assets/css/common.scss';

   .hd-language-item {
      padding: 4px 0;
      text-align: center;
      cursor: pointer;
      &:hover {
        background-color: rgba($color: $main_color_deep, $alpha: 0.2);
      }
      &.active {
        color: $main_color_deep;
        background-color: rgba($color: $main_color_deep, $alpha: 0.1);
        cursor: not-allowed;
      }
    }
</style>
<style scoped>
.unread{
  background: red;
  padding: 2px 3px;
  color: #fff;
  border-radius: 6px;
  position: relative;
  bottom: 12px;
  right: 2px;
}
.tenant-pop-up{
  display: flex;
}
.tenant-box{
  border-left: 1px solid #444;
  padding-left: 10px;
  margin-left: 10px;
  height: 400px;
  overflow: scroll;
  width: 70%;
}
.tenant-box-item{
  color: #444;
  font-size: 15px;
  cursor: pointer;
  padding: 5px;
}
.tenant-box-item:hover{
  background: #eee;
}
</style>